import { render, staticRenderFns } from "./DetailsList.vue?vue&type=template&id=5f357597"
import script from "./DetailsList.vue?vue&type=script&lang=ts"
export * from "./DetailsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports